import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliatePayoutsGet = {
    path: "/affiliate/payouts",
    method: ERouteHttpVerb.GET
};
export { routeLocationAffiliatePayoutsGet };
